/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import Accommodation from './pages/Accommodation';
import Budget from './pages/Budget';
import CeremonyDetails from './pages/CeremonyDetails';
import EmergencyContact from './pages/EmergencyContact';
import EntertainmentDetails from './pages/EntertainmentDetails';
import Florals from './pages/Florals';
import FoodBeverage from './pages/FoodBeverage';
import Honeymoon from './pages/Honeymoon';
import PhotographyDetails from './pages/PhotographyDetails';
import Transport from './pages/Transport';
import Calendar from './pages/Calendar';
import ScheduleHub from './pages/ScheduleHub';
import Catering from './pages/Catering';
import Checklist from './pages/Checklist';
import TasksHub from './pages/TasksHub';
import Considerations from './pages/Considerations';
import CouplesStudio from './pages/CouplesStudio';
import Dashboard from './pages/Dashboard';
import EventDetails from './pages/EventDetails';
import Features from './pages/Features';
import GuestExperience from './pages/GuestExperience';
import GuestRSVP from './pages/GuestRSVP';
import GuestSuite from './pages/GuestSuite';
import GuestSuiteQandA from './pages/GuestSuiteQandA';
import GuestSuiteSchedule from './pages/GuestSuiteSchedule';
import GuestSuiteAccommodation from './pages/GuestSuiteAccommodation';
import GuestSuiteTransport from './pages/GuestSuiteTransport';
import GuestSuiteRegistry from './pages/GuestSuiteRegistry';
import GuestSuitePolls from './pages/GuestSuitePolls';
import GuestSuiteLiveStream from './pages/GuestSuiteLiveStream';
import GuestSuiteExperience from './pages/GuestSuiteExperience';
import GuestSuitePolicies from './pages/GuestSuitePolicies';
import Guests from './pages/Guests';
import Home from './pages/Home';
import Invitations from './pages/Invitations';
import LiveStreaming from './pages/LiveStreaming';
import Messages from './pages/Messages';
import Moodboard from './pages/Moodboard';
import Music from './pages/Music';
import Notes from './pages/Notes';
import Onboarding from './pages/Onboarding';
import OurStory from './pages/OurStory';
import PhotoGallery from './pages/PhotoGallery';
import Photography from './pages/Photography';
import PlanSelection from './pages/PlanSelection';
import Policies from './pages/Policies';
import Pricing from './pages/Pricing';
import Registry from './pages/Registry';
import Schedule from './pages/Schedule';
import Seating from './pages/Seating';
import Styling from './pages/Styling';
import TodoList from './pages/TodoList';
import Vendors from './pages/Vendors';
import VowsSpeeches from './pages/VowsSpeeches';
import WebsiteCustomization from './pages/WebsiteCustomization';
import WeddingWebsite from './pages/WeddingWebsite';
import VendorMarketplace from './pages/VendorMarketplace';
import QandA from './pages/QandA';
import Polls from './pages/Polls';
import Beauty from './pages/Beauty';
import DailyUpdate from './pages/DailyUpdate';
import __Layout from './Layout.jsx';


export const PAGES = {
    "Accommodation": Accommodation,
    "Budget": Budget,
    "CeremonyDetails": CeremonyDetails,
    "EmergencyContact": EmergencyContact,
    "EntertainmentDetails": EntertainmentDetails,
    "Florals": Florals,
    "FoodBeverage": FoodBeverage,
    "Honeymoon": Honeymoon,
    "PhotographyDetails": PhotographyDetails,
    "Transport": Transport,
    "Calendar": ScheduleHub,
    "Catering": Catering,
    "Checklist": TasksHub,
    "Considerations": Considerations,
    "CouplesStudio": CouplesStudio,
    "Dashboard": Dashboard,
    "EventDetails": EventDetails,
    "Features": Features,
    "GuestExperience": GuestExperience,
    "GuestRSVP": GuestRSVP,
    "GuestSuite": GuestSuite,
    "GuestSuiteQandA": GuestSuiteQandA,
    "GuestSuiteSchedule": GuestSuiteSchedule,
    "GuestSuiteAccommodation": GuestSuiteAccommodation,
    "GuestSuiteTransport": GuestSuiteTransport,
    "GuestSuiteRegistry": GuestSuiteRegistry,
    "GuestSuitePolls": GuestSuitePolls,
    "GuestSuiteLiveStream": GuestSuiteLiveStream,
    "GuestSuiteExperience": GuestSuiteExperience,
    "GuestSuitePolicies": GuestSuitePolicies,
    "Guests": Guests,
    "Home": Home,
    "Invitations": Invitations,
    "LiveStreaming": LiveStreaming,
    "Messages": Messages,
    "Moodboard": Moodboard,
    "Music": Music,
    "Notes": Notes,
    "Onboarding": Onboarding,
    "OurStory": OurStory,
    "PhotoGallery": PhotoGallery,
    "Photography": Photography,
    "PlanSelection": PlanSelection,
    "Policies": Policies,
    "Pricing": Pricing,
    "Registry": Registry,
    "Schedule": ScheduleHub,
    "Seating": Seating,
    "Styling": Styling,
    "TodoList": TasksHub,
    "Vendors": Vendors,
    "VowsSpeeches": VowsSpeeches,
    "WebsiteCustomization": WebsiteCustomization,
    "WeddingWebsite": WeddingWebsite,
    "VendorMarketplace": VendorMarketplace,
    "QandA": QandA,
    "Polls": Polls,
    "Beauty": Beauty,
    "DailyUpdate": DailyUpdate,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};